import { action, makeObservable } from 'mobx';
import BaseStore from 'core/stores/BaseStore';
import { CarrierService } from 'common/data';

class CarrierStore extends BaseStore {
	constructor(rootStore) {
		super(new CarrierService(rootStore.app.baasic.apiClient));
		makeObservable(this);
	}

	@action async findCarriers(filter) {
		const carriers = await this.service.find(filter);
		this.response = carriers.data;
		return carriers.data;
	}

	@action async getCarrier(id, options) {
		const carrier = await this.service.get(id, options);
		this.item = carrier.data;
		return carrier.data;
	}

	@action async updateCarrier(carrier, sourceOfChange) {
		await this.service.update(carrier, sourceOfChange);
	}

	@action async createCarrier(carrier, sourceOfChange) {
		const response = await this.service.create(carrier, sourceOfChange);
		this.item = response;
		return this.item.data;
	}

	@action async deleteCarrier(carrier) {
		await this.service.delete(carrier);
	}

	@action async authorizeStamps() {
		await this.service.authorizeStamps();
	}

	@action async getAuthorizationResultStamps() {
		const oAuthResult = await this.service.authorizationResultStamps();
		return oAuthResult;
	}

	@action async authorizeUps() {
		await this.service.authorizeUps();
	}

	@action async getAuthorizationResultUps() {
		const oAuthResult = await this.service.authorizationResultUps();
		return oAuthResult;
	}

	@action async fetchFedexHubIds() {
		const response = await this.service.fetchFedexHubIds();
		return this.response = response.data;
	}
}

export default CarrierStore;
